import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import { InputField, LabelField, SelectField } from "components";
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoFieldOld";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { useSearch } from "hook";
import { addNewUserFromSchema } from "pages/ValidationSchema";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";

const ApplyLink = ({
    closeModal,
    account_id,
    refresh,
    setRefresh,
    setUserFamily,
    familyMember,
    row,
    setcheckCreateAccount,
    checkCreateAccount
}) => {
    const [search, setSearch] = useState(undefined);
    const { getAccessTokenSilently } = useAuth0();
    const { searchAction } = useSearch({ action: setSearch });
    const [loading, setLoading] = useState(false);
    const [subLoading, setSubLoading] = useState(false);
    const [contactsList, setContactsList] = React.useState([]);
    const [createAccount, setcreateAccount] = useState(false);
    const [account, setAccount] = useState({});

    async function fetchMyAPI1() {
        enableLoading(true);
        const token = await getAccessTokenSilently();
        await FinanceService.getACcountNamesForApplayLink(token, row?.Account?.id, search)
            .then((res) => {
                if (res?.accounts) {
                    res.accounts.map((item) => {
                        item.label = item.family_name;
                        item.value = item.account_id;
                        const firstActiveAgency = item?.addresses.length > 0 ? item?.addresses.find(item => item.active) : null;
                        item.address = firstActiveAgency !== null ? firstActiveAgency?.location?.formattedAddress : null
                        return item;
                    });
                    setContactsList(res?.accounts);
                }
                enableLoading(false);
            })
            .catch((err) => {
                toastr.error("Error", err?.data?.message);
            });
    }

    const enableLoading = (value) => {
        setLoading(value);
    };


    useEffect(() => {
        if (!account_id) fetchMyAPI1();
    }, [search]);
    

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: "",
            last_name: "",
            family_name: "",
            email: "",
            account: "",
        },
        validationSchema: createAccount ? addNewUserFromSchema : false,
        onSubmit: async (values) => {
            setSubLoading(true);
            const token = await getAccessTokenSilently();
            const input = {
                "newAccount": values?.account?._id,
                "oldAccount": account?._id
            };

            const payload = {
                "oldAccount": account?._id,
                "first_name": values?.first_name,
                "last_name": values?.last_name,
                "family_name": values?.family_name,
                "email_address": values?.email
            }

            createAccount ?
                await AuthService.UpdateMergeTransaction(payload, token)
                    .then((res) => {
                        setSubLoading(false);
                        closeModal();
                        setcheckCreateAccount(!checkCreateAccount);
                        if (res.result) {
                            toastr.success("Success", res.result ?? "Successfully Completed.");
                        }

                    })
                    .catch((err) => {
                        setSubLoading(false);
                        setcheckCreateAccount(!checkCreateAccount);
                        toastr.error("Error", err?.data?.message);
                    })
                :


                await AuthService.MergeTransaction(input, token)
                    .then((res) => {
                        setSubLoading(false);
                        closeModal();
                        setcheckCreateAccount(!checkCreateAccount);
                        if (res.result) {
                            toastr.success("Success", res.result ?? "Successfully Completed.");
                        }

                    })
                    .catch((err) => {
                        setSubLoading(false);
                        setcheckCreateAccount(!checkCreateAccount);
                        toastr.error("Error", err?.data?.message);
                    });
        },
    });

    useEffect(() => {
        if (familyMember === true) {
            setUserFamily(true);
        }
    }, []);


    React.useEffect(() => {
        async function fetchMyAPI() {
            enableLoading(true);
            const token = await getAccessTokenSilently();
            AuthService.getAccountById(row?.Account?.id, token)
                .then((res) => {
                    if (res) {
                        if (res[0] !== undefined) {
                            setAccount(res[0]);
                        } else {
                            toastr.error('Error', 'Member Not found');
                        }
                    }
                    enableLoading(false);
                })
                .catch((err) => {
                    enableLoading(false);
                });
        }
        if (row?.Account?.id) fetchMyAPI();
    }, [row]);


    useEffect(() => {
        if (account?.admin_name) {
            let fullName = account?.admin_name.split(' '),
                firstName = fullName[0],
                lastName = fullName[fullName.length - 1];

            formik.setFieldValue("first_name", firstName);
            formik.setFieldValue("last_name", lastName)
            formik.setFieldValue("email", account?.primary_email_address)
        }
    }, [account])

    const handleCreateAccount = () => {
        setcreateAccount(!createAccount)
        // formik.setFieldValue("first_name", "");
        // formik.setFieldValue("last_name", "")
        // formik.setFieldValue("email", "")
        // formik.setFieldValue("account", "")
    }

    if (account) {
        return (
            <div className="add-new-user">
                <div className="px-20 pt-10">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <InputField
                                {...{
                                    formik,
                                    title: "First Name",
                                    name: "first_name",
                                    placeholder: "First name",
                                    value: formik?.values?.first_name

                                }}
                                disabled
                            />
                        </div>
                        <div>
                            <InputField
                                {...{
                                    formik,
                                    title: "Last Name",
                                    name: "last_name",
                                    placeholder: "Last name",
                                    value: formik?.values?.last_name

                                }}
                                disabled
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                        <div>
                            <InputField
                                {...{
                                    formik,
                                    title: "Email",
                                    name: "email",
                                    placeholder: "Email",
                                    value: formik?.values?.email
                                }}
                                disabled
                            />
                        </div>
                        <div className="Width_data">
                            {
                                createAccount ?
                                    <div>
                                        <InputField
                                            {...{
                                                formik,
                                                title: "Account name",
                                                name: "family_name",
                                                placeholder: "Account name",
                                                value: formik?.values?.family_name
            
                                            }}
                                        />
                                    </div>
                                    :
                                    <div className="apply_create_account" onClick={handleCreateAccount}>Create new account</div>

                            }

                        </div>
                    </div>

                    {!createAccount && !account_id && (
                        <div className="sm-12 mt-4 AccountList">
                            <LabelField title="Account" />
                            <AsyncAutoCompleteField
                                mandatory={true}
                                {...{
                                    formik,
                                    name: "account",
                                }}
                                error={formik?.errors["account"]}
                                touched={formik?.touched["account"]}
                                onInputChange={(text) => searchAction(text)}
                                classNamePrefix="react-select"
                                options={contactsList}
                                isLoading={loading}
                                handleChange={(e) => formik.setFieldValue("account", e)}
                                value={formik.values.account}
                            />
                        </div>
                    )}
                    <div
                        className="form-group mt-10"
                        style={{ textAlign: "center", marginBottom: "0px" }}
                    >
                        <button
                            type="submit"
                            disabled={createAccount ? (!formik?.isValid || subLoading) : subLoading}
                            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                            onClick={() => formik.handleSubmit()}
                        >
                            <span style={{ fontSize: 13, fontWeight: "600" }}>
                                Apply
                            </span>
                            {subLoading && <span className="ml-3 spinner spinner-white"></span>}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <Loader />
        )
    }

};
export default ApplyLink;
